<template functional>
  <section class="bg-yellow">
    <h2 class="fs-l fw-l">Get in touch</h2>
    <a class="fs-m" :href="`mailto:saso.smark@gmail.com`"
      >saso.smark@gmail.com</a
    >
  </section>
</template>

<script>
export default {
  name: "TheContactSection"
};
</script>

<style lang="scss" scoped>
section {
  h2 {
    margin-bottom: 1rem;
  }
}
</style>
